

class VideoContainer extends HTMLElement {
    constructor() {
        super();
        if(this.getAttribute('data-has-video') != "false") {
          this.listeners();
        }

    }

    listeners() {
      var self = this;
      //video trigger
      var video = this.querySelector('.video__video');
      var videoTrigger = this.querySelector('[data-video-trigger]');
      var autoplayVideo = this.getAttribute('data-autoplay');
      var autoplayVideoOnScroll = this.getAttribute('data-autoplay-on-scroll');

      // console.log(autoplayVideoOnScroll);

      if (autoplayVideoOnScroll == 'true' ) {
        var videoObserver = new IntersectionObserver(function(videos) {
          if(videos[0].isIntersecting === true)
          console.log('play');
          self.openVideo();
        }, { threshold: [1] });
        videoObserver.observe(video);
      }
      if (autoplayVideo == 'true') {
        self.openVideo();
      }

      if(videoTrigger){
        videoTrigger.addEventListener('click', function(event){
          console.log('click on video image');
          self.openVideo();
        });
      }

      //video finished
      this.querySelector('[data-video]').addEventListener('ended', function() {
        self.closeVideo();
      });
      //video close button
      var videoCloseButton = this.querySelector('[data-video-close]');
      if(videoCloseButton != null) {
        videoCloseButton.addEventListener('click', function() {
          self.closeVideo();
        });
      }
    }

    openVideo() {
      this.classList.add('is--active');

      if (this.getAttribute('data-autoplay') == 'true' || this.getAttribute('data-autoplay-on-scroll') == 'true' ) {
        // Need to mute the video to allow autoplay
        this.querySelector('[data-video]').muted = true;
      }
      this.querySelector('[data-video]').play();
    }

    closeVideo() {
      // this.classList.remove('is--active');
      // this.querySelector('[data-video]').pause();
      // document.exitFullscreen();
    }

}

customElements.define('video-container', VideoContainer);
